const getProps = (obj, key) => key.split('.').reduce((a, b) => a && a[b], obj)

export const toObject = (prop) => prop.split('.').reduce((a, b) => ({ [a]: { [b]: {} } }))

export default getProps
